import { FC } from 'react';

type Props = {
	className?: string;
};

const Calendar_02_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M9.20073 10.8003H13.2007M6.80078 10.8003H6.80796M10.8007 14.0002H6.80078M13.2007 14.0002H13.1935'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.799 2V3.59997M5.19922 2V3.59997'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.39844 10.1947C2.39844 6.70897 2.39844 4.96607 3.40011 3.88318C4.40179 2.80029 6.01396 2.80029 9.2383 2.80029H10.7583C13.9826 2.80029 15.5948 2.80029 16.5965 3.88318C17.5981 4.96607 17.5981 6.70897 17.5981 10.1947V10.6056C17.5981 14.0913 17.5981 15.8342 16.5965 16.9171C15.5948 18 13.9826 18 10.7583 18H9.2383C6.01396 18 4.40179 18 3.40011 16.9171C2.39844 15.8342 2.39844 14.0913 2.39844 10.6056V10.1947Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.80078 6.7998H17.2005'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Calendar_02_Icon;
